import avatar1 from "./avatar1.jpg";
import avatar2 from "./avatar2.jpg";
import avatar3 from "./avatar3.jpg";

export const TestmonialsData = {
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc id velit augue. In eu ipsum non leo commodo malesuada non vel leo. Cras orci augue, finibus eu ipsum et, pellentesque ornare tortor. Cras accumsan congue dui sit amet facilisis. Nam et accumsan lacus. Donec pharetra tortor erat, quis sollicitudin sapien interdum eu. Nulla iaculis sem risus, eu facilisis diam accumsan sit amet.",
  PersonsData: [
    {
      id: "e1",
      name: "Emma Re",
      proffecy: "Fullstack Developer",
      imageSource: avatar1,
    },
    {
      id: "e2",
      name: "John Doe",
      proffecy: "Graphic Designer",
      imageSource: avatar2,
    },
    {
      id: "e3",
      name: "Emily Roe",
      proffecy: "Freelancer",
      imageSource: avatar3,
    },
  ],
};
